import Layout from '@/AppMain.vue';

const orders= {
    path: '/settings',
    name: 'Ustawienia',
    component: Layout,
    children:[
        {
            path: '/settings',
            name: 'Ustawienia',
            component: () => import('@/views/settings/browse'),
            meta: {title: 'Ustawienia', auth: true},
            redirect: '/settings/privacy',
            children:[
                {
                    path: '/settings/privacy',
                    name: 'Polityka prywatności',
                    component: () => import('@/views/settings/privacy'),
                    meta: {title: 'Ustawienia polityka prywatności', auth: true},
                },
                {
                    path: '/settings/regulations',
                    name: 'Regulamin',
                    component: () => import('@/views/settings/regulations'),
                    meta: {title: 'Regulamin', auth: true},
                },
                {
                    path: '/settings/notifications',
                    name: 'Powiadomienia',
                    component: () => import('@/views/settings/notifications'),
                    meta: {title: 'Powiadomienia', auth: true},
                }
            ]
        },
    ]
};
export default orders;
